export default __webpack_public_path__ + "static/media/lockr-maintenance.95d60b03.svg";